<template>
    <Head>
        <title>Sila tunggu....menuju ke gerbang pembayaran</title>
    </Head>

    <div style="width: 100vw">
        <div class="col">
            <section class="alert alert-warning py-3" role="alert">
                <p class="fs-3 text-center">
                    <b>Sila tunggu...</b><br>
                    Kami sedang membawa anda ke gerbang pembayaran
                </p>
            </section>
            <form :action="payurl" method="POST" ref="wrazer">
                <input type=hidden name="agency" :value="paymerchant">
                <input type=hidden name="returnUrl" :value="returnurl">
                <input type=hidden name="amount" :value="(parseFloat(transaksi.AmaunKeseluruhan)+0.5).toFixed(2)">
                <input type=hidden name="orderid" :value="orderid">
                <input type=hidden name="bill_name" :value="transaksi.Nama">
                <input type=hidden name="bill_email" :value="transaksi.EMel">
                <input type=hidden name="bill_mobile" :value="transaksi.TelefonBimbit">
                <input type=hidden name="bill_desc" value="Pembayaran Wakaf Pahang">
                <input type=hidden name="country" value="MY">
                <input type=hidden name="vcode" :value="codedd">
            </form>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import {Head} from "@inertiajs/vue3";
let wrazer = ref();
const data = defineProps({
    orderid: {type: String, required: true},
    payurl: {type: String, required: true},
    paymerchant: {type: String, required: true},
    returnurl: {type: String, required: true},
    codedd: {type: String, required: true},
    transaksi: {type: Object, required: true},
})
onMounted(()=>{
    document.getElementsByTagName("body")[0].style.width = "100%";
    document.getElementsByTagName("body")[0].style.display = "grid";
    document.getElementsByTagName("body")[0].style.placeItems = "center";
    document.getElementsByTagName("html")[0].style.width = "100%";
    document.getElementsByTagName("html")[0].style.height = "100%";
    document.getElementsByTagName("body")[0].style.height = "100%";
    setTimeout(function () {
            wrazer.value.submit();
        }
        , 1000);
});
</script>


